import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { FixtureMediaThumbnail } from './FixtureMediaThumbnail';
import { ResponsiveFixtureMediaThumbnail } from './ResponsiveFixtureMediaThumbnail.jsx';

import { useGetContentQuery } from '../../../../../store/js/modules/api/content-api';

const PAGE_SIZE = 10;

const PROGRAM_CATEGORIES = {
    highlights: 'ProgramCategory:Match Highlights',
    miniMatches: 'ProgramCategory:Mini-Matches',
    replays: 'ProgramCategory:Match Replays',
    preview: 'match-preview'
};

const THUMBNAIL_VARIANT = [
    {
        name: 'default',
        size: { width: 152, height: 86 },
        multipliers: [1, 2, 3]
    }
];

const TAG_GROUPS = {
    [PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING]: [
        PROGRAM_CATEGORIES.preview
    ],
    [PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED]: [
        PROGRAM_CATEGORIES.highlights,
        PROGRAM_CATEGORIES.miniMatches,
        PROGRAM_CATEGORIES.replays
    ]
};

export const FixtureMedia = ({ match, matchStatus }) => {
    const [category, setCategory] = useState('');

    const tagList = TAG_GROUPS[matchStatus]
        ? TAG_GROUPS[matchStatus].map((item) => `"${item}"`)
        : [];

    const requestConfig = {
        type: 'VIDEO',
        params: {
            pageSize: PAGE_SIZE,
            references: `AFL_MATCH:${match.id}`,
            tagExpression: `(${tagList?.join('or')})`
        }
    };

    const { data: requestData = [] } = useGetContentQuery(requestConfig);
    const videoData = requestData?.content;

    const video = useMemo(() => {
        if (matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING) {
            return PULSE.app.common.content.getContentModel(
                videoData?.find((item) =>
                    item.tags.find((tag) => {
                        setCategory(PROGRAM_CATEGORIES.preview);
                        return tag.label === PROGRAM_CATEGORIES.preview;
                    })
                ),
                THUMBNAIL_VARIANT
            );
        }
        return PULSE.app.common.content.getContentModel(
            videoData?.find((item) =>
                item.tags.find((tag) => {
                    setCategory(PROGRAM_CATEGORIES.highlights);
                    return tag.label === PROGRAM_CATEGORIES.highlights;
                })
            ) ||
                videoData?.find((item) =>
                    item.tags.find((tag) => {
                        setCategory(PROGRAM_CATEGORIES.miniMatches);
                        return tag.label === PROGRAM_CATEGORIES.miniMatches;
                    })
                ) ||
                videoData?.find((item) =>
                    item.tags.find((tag) => {
                        setCategory(PROGRAM_CATEGORIES.replays);
                        return tag.label === PROGRAM_CATEGORIES.replays;
                    })
                ),
            THUMBNAIL_VARIANT
        );
    }, [videoData]);

    return (
        <>
            {video && (
                <>
                    <FixtureMediaThumbnail video={video} category={category} />
                    <ResponsiveFixtureMediaThumbnail
                        video={video}
                        category={category}
                    />
                </>
            )}
        </>
    );
};

FixtureMedia.propTypes = {
    match: PropTypes.object.isRequired,
    matchStatus: PropTypes.string
};
